import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { layout } from 'utils/styles/theme';

const columns = layout.columns.max;

export const Wrapper = styled(motion.div)`
  padding: 277px 0 120px;

  display: grid;
  grid-template-columns:
    [out-left] 16px
    repeat(${columns}, [content] minmax(0px, 1fr))
    [out-right] 16px;

  ${mediaDesktop(`
    grid-template-columns: [out-left] 92px repeat(${columns}, [content] minmax(0px, 1fr)) [out-right] 92px;
    grid-column-gap: 32px;
    padding: 329px 0 240px;
  `)}
`;

export const HeadingWrapper = styled.div`
  grid-column: 2/-2;
  margin-bottom: 136px;

  margin-bottom: 56px;

  ${mediaDesktop(css`
    margin-bottom: 80px;
  `)}

  h1 {
    ${({ theme: { locale } }) => setTypography('heading1', locale)}
  }

  h2 {
    ${({ theme: { locale } }) => setTypography('heading2', locale)}
  }
  h3 {
    ${({ theme: { locale } }) => setTypography('heading3', locale)}
  }

  h4 {
    ${({ theme: { locale } }) => setTypography('heading4', locale)}
  }

  h5 {
    ${({ theme: { locale } }) => setTypography('heading5', locale)}
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-bottom: 20px;

    ${mediaDesktop(css`
      margin-bottom: 24px;
    `)}
  }

  p {
    ${({ theme: { locale } }) => setTypography('body', locale)}
    margin-bottom: 20px;

    ${mediaDesktop(css`
      margin-bottom: 24px;
    `)}
  }

  ul {
    list-style-type: disc;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    -webkit-padding-start: 25px;
  }
`;

export const Title = styled.div`
  ${({ theme: { locale } }) => setTypography('display', locale)}
  margin-bottom: 136px;
`;
